<template>
  <section class="qywh-wrapper" id="qywh">
    <div class="section">
      <div class="left">
        <div class="desc-title"><span class="active">{{ $t('culture.title') }}</span><span> / CULTURE</span></div>
        <div class="item first"><div class="h1">{{ $t('culture.missionTitle') }}</div><div class="desc">{{ $t('culture.missionDesc') }}</div></div>
        <div class="item"><div class="h1">{{ $t('culture.visionTitle') }}</div><div class="desc">{{ $t('culture.visionDesc') }}</div></div>
        <div class="item"><div class="h1">{{ $t('culture.codeTitle') }}</div><div class="desc">{{ $t('culture.codeDesc') }}</div></div>
        <div class="item"><div class="h1">{{ $t('culture.staffCodeTitle') }}</div><div class="desc">{{ $t('culture.staffCodeDesc') }}</div></div>
        <div class="item"><div class="h1">{{ $t('culture.philosophyTitle') }}</div><div class="desc">{{ $t('culture.philosophyDesc') }}</div></div>
      </div>
      <div class="right"><img src="@/static/image/about3.png" alt="culture" /></div>
    </div>
  </section>
</template>

<script>
export default { name: 'CultureSection' }
</script>

<style scoped lang="scss">
.qywh-wrapper { width: 100%; height: 610px; background: #f7f7f7; }
.section { width: 1200px; height: 610px; margin: 0 auto; display: flex; }
.left { margin-right: 20px;text-align: left; }
.desc-title { color: #929292; margin-top: 40px; }
.desc-title .active { color: #1c51a3; font-size: 28px; }
.item { margin-top: 30px; }
.item .h1 { color: #333; font-size: 20px; }
.item .desc { color: #666; margin-top: 10px; line-height: 1.7; }
.right img { height: 610px; }
</style>

